<template>
	<TeamingChip2 class="browse-topics-chip">
		<template #left-icon>
			<FontAwesomeIcon :icon="[ `far`, `message-lines` ]" />
		</template>
		<template #default>
			{{ translate("text") }}
		</template>
	</TeamingChip2>
</template>

<script>
import {
	TeamingChip2
} from "@teaming/common-ui";

export default {
	name: "BrowseTopicsChip",
	components: {
		TeamingChip2,
	},
	methods: {
		translate( key, args = {} ) {
			const { name, } = this.$options;
			return this.$t( `common-team.components.${ name }.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
